// ** Initial State
const initialState = {
  data: [],
  total: 1,
  from: 0,
  to: 0,
  params: {},
  selectedData: null
}

const createReference = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_DATA_CREATE_REFERENCE':
      return {
        ...state,
        data: action.data,
        total: action.totalPages,
        params: action.params,
        from: action.from,
        to: action.to,
      }
    case 'SHOW_DATA_REFERENCE_LOGS':
      return {
        ...state,
        data: action.data,
        total: action.totalPages,
        params: action.params,
        from: action.from,
        to: action.to,
        params: action.params
      }
    case 'GET_CREATE_REFERENCE':
      return { ...state, selectedData: action.selectedData }
    case 'ADD_CREATE_REFERENCE':
      return { ...state }
    case 'EDIT_CREATE_REFERENCE':
      return { ...state }
    case 'DELETE_CREATE_REFERENCE':
      return { ...state }
    default:
      return { ...state }
  }
}
export default createReference
